export function scrollToElementWhenReady(id, options = {}, timeoutMs = 5000) {
  if (typeof document === 'undefined' || !document.body) return () => {};

  let animationFrame;
  let observer;
  let timeout;
  let cancelled = false;

  const cleanup = () => {
    cancelled = true;
    if (animationFrame !== undefined) cancelAnimationFrame(animationFrame);
    if (observer !== undefined) observer.disconnect();
    if (timeout !== undefined) clearTimeout(timeout);
  };

  const findAndScroll = () => {
    const target = document.getElementById(id);
    if (!target) return false;

    if (observer !== undefined) observer.disconnect();
    if (timeout !== undefined) clearTimeout(timeout);
    animationFrame = requestAnimationFrame(() => {
      if (!cancelled) target.scrollIntoView(options);
    });
    return true;
  };

  animationFrame = requestAnimationFrame(() => {
    animationFrame = undefined;
    if (cancelled || findAndScroll()) return;

    observer = new MutationObserver(findAndScroll);
    observer.observe(document.body, { childList: true, subtree: true });
    timeout = setTimeout(cleanup, timeoutMs);
  });

  return cleanup;
}
